export default __webpack_public_path__ + "static/media/char-c3po.bd8f0ed5.jpg";